import { Link } from 'react-router-dom';
import AppShell from '../components/AppShell';

export default function NotFound() {
  return (
    <AppShell>
      <h1 className="t-h1 text-ink">That page isn&rsquo;t here.</h1>
      <p className="t-body measure mt-4 text-grey-600">
        The link may be old, or the address may have a typo in it.
      </p>
      <Link
        to="/"
        className="t-body mt-8 inline-block rounded-sm text-green-700 underline decoration-1 underline-offset-4 hover:decoration-2"
      >
        Go back to the start
      </Link>
    </AppShell>
  );
}
